import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { requestHandler } from '../helper'
import { adminLogout } from '../controller'
import ChangePassword from '../components/ChangePassword';
import Profile from '../components/Profile';
import axiosInstance from '../utils/axiosConfig';

function Header({ title, onToggle }) {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        name: '',
        email: '',
    })
    const Logout = async () => {
        try {
            await requestHandler(
                async () => await adminLogout(),
                null,
                () => {
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                },
                () => { }
            );
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/user/get`)
                if (response.status === 200) {
                    setFormData({
                        firstName: response.data.data.firstName,
                        lastName: response.data.data.lastName,
                        email: response.data.data.email,
                    })

                }

            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchProfile()
    }, [])
    return (
        <>
            <header>
                <div className="d-flex justify-content-between align-items-center gap-3">
                    <div className='d-flex align-items-start gap-3'>
                        <img onClick={onToggle} className='toggle d-xl-none' src="/images/png/line.png" alt="" />
                        <h3>{title}</h3>
                    </div>


                    <Dropdown align="end">
                        <Dropdown.Toggle id="dropdown-custom-components" className='p-0 bg-transparent border-0'>
                            <div className='admin-profile'>
                                <img className='admin' src="/images/png/admin.png" alt="" />
                                <div className='d-none d-md-block'>
                                    <h5>Hello, {formData.firstName}</h5>
                                    <p>{formData.lastName}</p>
                                </div>
                                <img className='arrow arrow-bottom' src="/images/png/bottom.png" alt="" />
                                <img className='arrow arrow-top' src="/images/png/top.png" alt="" />
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Profile
                                formData={formData}
                                setFormData={setFormData}
                            />
                            <ChangePassword />
                            <Dropdown.Item onClick={Logout}>
                                <img src="/images/png/logout.png" width={24} alt="" />
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </header>

        </>
    )
}

export default Header